import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {FormBuilder, FormGroup} from "@angular/forms";

import {MessageService, ProcedureService, ReportService} from "@services";
import {AppBaseComponent} from "@utils";

/**
 * Componente con la bandeja de reportes devueltos
 */
@Component({
  selector: 'app-reports-returned',
  templateUrl: './reports-returned.component.html',
  styleUrls: ['./reports-returned.component.scss']
})
export class ReportsReturnedComponent extends AppBaseComponent implements OnInit, AfterViewInit {

  /**
   * Paginador de la bandeja
   */
  @ViewChild(MatPaginator) paginator: MatPaginator;

  /**
   * Objeto para ordenar los tramites de la bandeja
   */
  @ViewChild(MatSort) sort: MatSort;

  public dateForm: FormGroup;
  tableFilter: any[] = [];
  showFormByUser: boolean = false;
  tramiteSeleccionado: any;
  pageCantidad: number = 0;


  /**
   * Opciones para el total de registros por página
   */
  public pageSizeOptions: number[] = [10, 25, 50, 100];

  registrotamanio: number;

  constructor(private fb: FormBuilder,
              private procedureService: ProcedureService,
              private popUpService: MessageService,
              private reportService: ReportService)
  {
    super();
    this.dateForm = this.fb.group({
      textToSearch: [''],
      pageSize: [10],
      pageNumber: [1],
      statusId: [4],
      initial_date: [null, [ super.dateValidator ]],
      final_date: [null,[ super.dateValidator ]],
    });
  }

  /**
   * Hook cuando el componente ya se construyó pero no ha renderizado
   */
  ngOnInit(): void {
    this.getListaTramites();
  }

  /**
   * Hook cuando el componente ya renderizó todas las vistas
   */
  ngAfterViewInit(): void {
    this.paginator._intl.getRangeLabel = this.getRangeDisplayText;
  }


  getListaTramites() {

    let initalDate = this.dateForm.get('initial_date').value;
    let finalDate = this.dateForm.get('final_date').value

    if (finalDate < initalDate) {
      this.popUpService.errorAlert("La fecha final no puede ser menor a la fecha inicial",3000)
      return;
    }

    let data = {
      pageSize: this.dateForm.get('pageSize').value,
      pageNumber: this.dateForm.get('pageNumber').value,
      textToSearch: this.dateForm.get('textToSearch').value,
      statusId: this.dateForm.get('statusId').value,
      initialDate: initalDate,
      finalDate: finalDate,
    };

    this.popUpService.infoAlert('Buscando tramites...', 4000);
    this.reportService.getFilterReport(data).subscribe((values) => {
      this.tableFilter = values['items'];
      this.registrotamanio = values['totalRows'];
      if(this.registrotamanio == 0) {
        this.popUpService.errorAlert("No existen solicitudes con los filtros aplicados",3000)
      }
    });
  }

  /**
   * Cambia la página en la tabla actualizando su información
   * @param e Evento del paginador
   */
  cambiarpagina(e: PageEvent) {
    this.dateForm.get('pageNumber').setValue(e.pageIndex + 1);
    this.getListaTramites();
  }

  /**
   * Actualiza la lista de solicitudes
   */
  public changeDataTable(): void {
    this.dateForm.get('pageNumber').setValue(1);
    this.paginator.firstPage();
    this.getListaTramites();
  }

  getTramiteActual(id): void {
    this.popUpService.infoAlert('Cargando tramite...', 4000);

    this.procedureService.getById(id).subscribe((resp) => {
      this.tramiteSeleccionado = resp;
      this.showFormByUser = true;
    });
  }

  public cancelFrm() {
    this.showFormByUser = false;
  }

  getErrorMessage(field: string): string {
    let message;
    let fechaErronea = "La fecha no puede ser una fecha futura o superior a la de hoy";

    if(this.isTouchedField(this.dateForm, field))
    {
      if(this.dateForm?.get(field).hasError('required'))
      {
        message='Es Requerido';
      }
      else if(this.dateForm?.get(field).hasError('invalidDate'))
      {
        message = fechaErronea;
      }
    }

    return message;
  }

  verificarFecha( ){
    //Bloquea del calendario desplegable
    const datepicker = document.getElementById('initial_date');
    const datepicker2 = document.getElementById('final_date');
    const today = new Date();
    let date = today.getDate() > 9 ? today.getDate() :
      `0${today.getDate()}`;
    let month = today.getMonth() > 9 ? today.getMonth() + 1 :
      `0${today.getMonth() + 1}`;
    let year = today.getFullYear();

    datepicker.setAttribute('max', `${year}-${month}-${date}`);
    datepicker2.setAttribute('max', `${year}-${month}-${date}`);
  }

  /**
   * Ordena ascendentemente la bandeja
   * @param nameData
   * @param type
   */
  sortAscDes(nameData, type){
    this.tableFilter.sort((x,y) => {
      let a = x[nameData].toLowerCase();
      let b = y[nameData].toLowerCase();
      let operaction;
      if(type === 'up'){
        // tslint:disable-next-line: no-unused-variable
        operaction =  (a > b) ?  1 : (a < b) ?- 1: 0;
      }else{
        // tslint:disable-next-line: no-unused-variable
        operaction =  (a > b) ? - 1 : (a < b) ? 1: 0;
      }
      return  operaction;
    })
  }

  /**
   * Ordena descendentemente la bandeja
   * @param nameData
   * @param type
   */
  sortAscDesNumber(nameData, type){
    this.tableFilter.sort((x,y) => {
      let a = x[nameData];
      let b = y[nameData];
      let operaction;
      if(type === 'up'){
        // tslint:disable-next-line: no-unused-variable
        operaction =  (a > b) ?  1 : (a < b) ?- 1: 0;
      }else{
        // tslint:disable-next-line: no-unused-variable
        operaction =  (a > b) ? - 1 : (a < b) ? 1: 0;
      }
      return  operaction;
    })
  }


  /**
   * Modifica el texto del label del paginador, cantidad de registros por pagina
   * @param page
   * @param pageSize
   * @param length
   */
  getRangeDisplayText = (page: number, pageSize: number, length: number) => {
    const initialText = `Ver trámites`; // customize this line
    if (length == 0 || pageSize == 0) {
      return `${initialText} 0 of ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex =
      startIndex < length
        ? Math.min(startIndex + pageSize, length)
        : startIndex + pageSize;
    return `${initialText} ${startIndex + 1} a ${endIndex} de ${length}`; // customize this line
  };

}
